import React, { useState } from 'react'
import { Container } from '@material-ui/core'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './components/Home/Home'
import Dashboard from './components/Dashboard/Dashboard'
import ListColor from './components/ListColor/ListColor'
import Login from './components/Login/Login'
import Password from './components/Password/Password'
// import AddInstructor from './components/AddInstructor/AddInstructor'
// import EditInstructor from './components/EditInstructor/EditInstructor'
import AddColorMixing from './components/AddColorMixing/AddColorMixing'
import EditColorMixing from './components/EditColorMixing/EditColorMixing'
import 'bootstrap/dist/css/bootstrap.min.css'
import { URL } from './constants/actionTypes'
import mainLogo from './images/hipic-logo.png'
import mainLogoMb from './images/hipic-logo_mobile.png'
import { useMediaQuery } from 'react-responsive'
const App = () => {
  const user = JSON.parse(localStorage.getItem('colorMixingHipic'))
  const client = JSON.parse(localStorage.getItem('colorMixingPasswordHipic'))
  let [checkPassword, setCheckPassword] = useState(false)
  let [checkLogin, setCheckLogin] = useState(false)
  function handleState(newValue) {
    setCheckLogin(newValue)
  }
  function handleStatePassword(newValue) {
    setCheckPassword(newValue)
  }
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })

  return (
    <BrowserRouter>
      <Container maxWidth='xl'>
        <div
          style={{
            textAlign: 'center',
            marginBottom: '10px',
            marginTop: '15px',
            position: 'relative',
            zIndex: 9
          }}
        >
          {isDesktopOrLaptop && (
            <a href='/'>
              <img src={mainLogoMb} style={{ width: '150px' }} />
            </a>
          )}
          {isTabletOrMobile && (
            <a href='/'>
              <img src={mainLogoMb} style={{ width: '150px' }} />
            </a>
          )}
        </div>
        <Routes>
          <Route
            checkPassword={handleStatePassword}
            path={URL + '/'}
            exact
            element={<Home />}
          />
          <Route
            path={URL + '/login'}
            exact
            element={<Login checkLogin={handleState} />}
          />
          <Route
            path={URL + '/password'}
            exact
            element={<Password checkPassword={handleStatePassword} />}
          />
          <Route path={URL + '/dashboard'} exact>
            <Route
              index={true}
              element={<Dashboard />}
              // element={<Dashboard checkLogin={handleState} />}
            />
            <Route
              index={false}
              path='add-color'
              element={<AddColorMixing />}
            />
            <Route index={false} path='list-color' element={<ListColor />} />
            <Route
              index={false}
              path='edit-color'
              element={<EditColorMixing />}
            />
          </Route>
        </Routes>
      </Container>
    </BrowserRouter>
  )
}

export default App
